import { useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { UseI18n } from '../../../../../common/hooks/useI18n'
import { Loading } from '../../../../../common/loading'
import Tree from '../../../../../common/tree'
import { getAllParentChecked } from '../../../../../common/tree/helper'
import EventEmitter, {
  SHOW_POPUP_ERROR,
} from '../../../../../helpers/EventEmitter'
import {
  CRITERIA_GROUP,
  INDUSTRY_TYPE,
  MAX_INDICATOR,
} from '../../../common/constant'
import {
  changeAlertPopup,
  selectIsLoadingSomeData,
} from '../../../common/store/slice'
import {
  changeCriteria,
  selectCriteria,
  selectSelectedIndicatorCount,
} from '../../store/slice'
import { selectIndustryICB } from './../../../common/store/slice'

export const ICB = ({ keyword }) => {
  const dispatch = useDispatch()

  const icbTree = useSelector(selectIndustryICB)
  const isLoadingSomeData = useSelector(selectIsLoadingSomeData)
  const criteriaIndustryType = useSelector(
    selectCriteria([CRITERIA_GROUP.INDUSTRY, 'industryType']),
  )
  const selectedIndicatorCount = useSelector(selectSelectedIndicatorCount)
  const listChecked = useSelector(
    selectCriteria([CRITERIA_GROUP.INDUSTRY, 'listIdCheckedTree']),
  )
  const industryUsedMessage = UseI18n('errorCommon.ONE_TYPE_OF_INDUSTRY_USED')

  const listParentChecked = useMemo(() => {
    return getAllParentChecked(
      icbTree,
      'id',
      criteriaIndustryType === INDUSTRY_TYPE.ICB ? listChecked : [],
    )
  }, [icbTree, listChecked, criteriaIndustryType])

  const canAddToCriteria =
    !criteriaIndustryType ||
    listChecked.length === 0 ||
    criteriaIndustryType === INDUSTRY_TYPE.ICB

  const setListChecked = (value) => {
    if (!canAddToCriteria) {
      EventEmitter.dispatch(SHOW_POPUP_ERROR, {
        messages: [industryUsedMessage],
      })
      return
    }
    if (selectedIndicatorCount >= MAX_INDICATOR) {
      dispatch(
        changeAlertPopup({
          isShow: true,
          title: 'screening.WARNING',
          message: 'screening.MAX_INDICATOR_MESS',
          translateProps: { max: MAX_INDICATOR, dangerousHTML: true },
        }),
      )
      return
    }

    if (!criteriaIndustryType || criteriaIndustryType !== INDUSTRY_TYPE.ICB) {
      dispatch(
        changeCriteria({
          path: [CRITERIA_GROUP.INDUSTRY, 'industryType'],
          data: INDUSTRY_TYPE.ICB,
        }),
      )
    }
    dispatch(
      changeCriteria({
        path: [CRITERIA_GROUP.INDUSTRY, 'listIdCheckedTree'],
        data: value,
      }),
    )
  }

  return (
    <>
      {isLoadingSomeData ? (
        <Loading />
      ) : Object.keys(icbTree).length ? (
        <Tree
          treeData={icbTree}
          idKey={'id'}
          nameKey="name"
          valueSearch={keyword.trim()}
          additionSearchKeys={['code']}
          listChecked={canAddToCriteria ? listChecked : []}
          setListChecked={setListChecked}
          disabledCheckDbClick
          isHaveCheckbox
          lineClamp={2}
          itemDefaultOpen={listParentChecked}
        />
      ) : (
        <></>
      )}
    </>
  )
}
